<template>
    <ac-layout-form
        v-if="canRender"
        title="申请续行"
        @back="back">
        <van-cell-group>
            <div class="fd-input-info">
                <van-field
                    v-model="formData.cSqr"
                    required
                    disabled
                    clearable
                    border
                    input-align="right"
                    label="申请人"
                ></van-field>
                <van-field
                    class="van-field--column"
                    maxlength="200"
                    required
                    v-model="formData.cSqxxyy"
                    type="textarea"
                    label="申请人续行原因"
                    placeholder="请输入内容"
                ></van-field>
                <van-field class="van-field--column van-field--no-value"
                           required
                           readonly>
                    <template slot="label">
                        <span>续行保全申请书</span>
                    </template>
                </van-field>
                <!-- <p class="fd-com-warning-tip" v-text="mbxzts"></p> -->
<!--                    上传组件 -->
                <ac-upload-file
                    v-model="sqsclList"
                    :upload-param="uploadFileParam"
                    :upload-url="uploadFileUrl"
                    :delete-url="deleteFileUrl"
                    :delete-param="deleteFileParam"></ac-upload-file>
            </div>
        </van-cell-group>
        <template slot="footer">
            <van-button
                class="guarantee-button"
                type="info"
                size="normal "
                round plain
                @click="back"
            >
                取消
            </van-button>
            <van-button
                class="guarantee-button submit-btn"
                type="info"
                size="normal "
                round
                @click="saveBqReile"
            >
                提交
            </van-button>
        </template>
    </ac-layout-form>
</template>

<script>
    // 表单布局
    import acLayoutForm from '@/components/app/layout/form/index.vue';
    // 上传文件
    import acUploadFile from '@/components/app/upload-file/index.vue';
    import validate from '../../utils/validator/validator';
    import {
        sqsclRule,
        cSqxxyy
    } from '../../utils/validator/rules';
    import {mbxzts} from '../../utils/consts';
    // 创建id
    import {createId} from "@/utils/common";
    import request from "@/api/axios";

    export default {
        components: {
            acLayoutForm,
            acUploadFile
        },
        data() {
            return {
                formData: {
                    cSqr: '',
                    cSqxxyy: '',
                },
                postData: {
                    // 保全id
                    cBqid: this.$route.query.bqid,
                    cSqr: '',
                    cSqsid: '',
                    cTjid: '',
                    cSqxxyy: '',
                    // 申请编号
                    cSqbh: this.$route.query.sqbh,
                },
                sqsclList: [],
                sqrList: [],
                tjid: '',
                mbxzts: mbxzts,
                // 上传文件url
                uploadFileUrl: 'ssbq/api/sccls/bgdb/sccl',
                // 删除文件url
                deleteFileUrl: 'ssbq/api/sccls/bgsq/bg/delsccl',
                // 是否可以渲染
                canRender: false
            }
        },
        computed: {
            // 上传的请求参数
            uploadFileParam() {
                return {
                    bqid: this.postData.cBqid,
                    dbid: '',
                    tjid: this.tjid,
                    cllx: 1,
                    sqslx: '304'
                }
            },
            // 删除文件的请求参数
            deleteFileParam() {
                return {
                    cllx: 1
                }
            }
        },
        created() {
            this.gainId();
            this.initBqSqrs();
        },
        methods: {

            /**
             * 保存
             * */
            saveBqReile() {
                // 校验表单
                this.validateForm().then(() => {
                    this.postData.cSqxxyy = this.formData.cSqxxyy;
                    this.$axios.post('ssbq/api/bqsq/xx/tj?bqid=' + this.postData.cBqid, this.postData)
                        .then(res => {
                            if (res.code === 200) {
                                this.$notify({'type': 'success', 'message': '申请续行提交成功'});
                                history.go(-1);
                            } else {
                                this.$notify(res.message);
                            }
                        })
                        .catch(() => {
                            this.$notify("系统异常");
                        })
                }).catch(error => {
                    console.log(error);
                });

            },

            /**
             * 关联id
             * */
            gainId() {
                let currentBqid = this.$route.query.bqid;
                let currentSqbh = this.$route.query.sqbh;
                this.postData.cBqid = currentBqid;
                this.postData.cSqbh = currentSqbh;
                createId().then(id => {
                    this.tjid = id;
                    this.postData.cTjid = id;
                })
                    .catch(() => {
                        this.$notify("系统异常");
                    });
            },

            /**
             * 初始化申请人
             * @returns {void}
             * */
            initBqSqrs() {
                this.$axios.get("ssbq/api/sqrs?bqid=" + this.postData.cBqid)
                    .then(res => {
                        if (res.code == 200) {
                            let sqrs = "";
                            let sqrIds = "";
                            res.data.forEach((item) => {
                                let sqr = {}
                                sqr.cId = item.cId
                                if (item.cSqrlx == "1") {
                                    sqr.sqrmc = item.cSqrxm
                                } else {
                                    sqr.sqrmc = item.cQymc
                                }
                                sqrs = sqrs.concat(sqr.sqrmc, "、");
                                sqrIds = sqrIds.concat(sqr.cId, ",");
                                this.sqrList.push(sqr);
                            });
                            this.formData.cSqr = sqrs.substring(0, sqrs.length - 1);
                            this.postData.cSqr = sqrIds.substring(0, sqrIds.length - 1);
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(function () {
                    this.$notify("系统异常");
                });
            },

            /**
             * 请求删除申请材料
             * @param {Object} params 请求参数
             * @returns {Promise}
             * */
            requestDelSccl(params) {
                return request({
                    url:'ssbq/api/sccls/bgsq/delsqcl',
                    method:'delete',
                    params: {
                        time: new Date().getTime(),
                        ...params
                    }
                })
            },

            /**
             * 返回
             * */
            back() {
                // 如果没有上传材料，直接返回
                if (!this.sqsclList.length) {
                    // 直接返回
                    history.go(-1);
                    return;
                }
                // 删除上传材料再返回
                this.requestDelSccl({
                    cDbid: '',
                    isDeldbl: false,
                    isDelsqs: false,
                    // 变更id
                    cBgid: this.tjid,
                }).then(() => {
                    history.go(-1);
                }).catch(() => {
                    this.$notify("系统异常");
                });
            },
            downloadTemplate() {
                window.open("wsbq/ssbq/api/wjgl/tempdownload/" + 7);
            },

            /**
             * 验证表单
             * @returns {Promise}
             * */
            validateForm() {
                var descriptor = {
                    // 续行申请原因
                    cSqxxyy: cSqxxyy,
                    // 续行申请书
                    sqs: sqsclRule,

                };// 校验表单数据
                const validated = validate(descriptor, {
                    cSqxxyy: this.formData.cSqxxyy,
                    sqs: this.sqsclList
                });
                return validated;
            }
        },
        //进入该页面时，刷新页面，要不上传会导致页面刷新
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(from.name == 'myPreservation'){
                    // 如果是从保全列表过来的需要刷新下页面，否则在手机上上传会有问题
                    window.location.reload();
                }
                // 可以进行渲染
                vm.canRender = true;
            });
        }
    }
</script>
